import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import {
  isAuthenticatedSelector,
  isAuthenticatingSelector,
} from "@stores/slices/userSlice";
import { isClient } from "@utils/common.util";
import {
  LOGIN_ROUTE_PATH,
  MY_PROFILE_ROUTE_PATH,
  REGISTER_ROUTE_PATH,
} from "@const/route-paths.const";
import { isWebview, clickAccountButtonNative } from "@utils/webview.util";

// eslint-disable-next-line react/display-name
const withAuth = (WrappedComponent: React.FC) => (props: any) => {
  // this hoc only supports client side rendering.
  if (isClient()) {
    const router = useRouter();
    const path = router.pathname;
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const isAuthenticating = useSelector(isAuthenticatingSelector);

    // is fetching session (eg. show spinner)
    if (isAuthenticating) {
      return null;
    }

    // If user is not logged in, return login component
    if (path !== LOGIN_ROUTE_PATH && path !== REGISTER_ROUTE_PATH) {
      if (!isAuthenticated) {
        console.log("LOGIN_ROUTE_PATH", LOGIN_ROUTE_PATH);
        router.push(LOGIN_ROUTE_PATH);
        if (isWebview()) {
          clickAccountButtonNative();
        }
        return null;
      } else if (path === "/") {
        router.push(MY_PROFILE_ROUTE_PATH); // default page after login when call root path
        return null;
      }
    } else {
      if (isAuthenticated) {
        router.push(MY_PROFILE_ROUTE_PATH); // default page after login
        return null;
      }
    }

    // If user is logged in, return original component
    return <WrappedComponent {...props} />;
  }

  return null;
};

export default withAuth;
